module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-Header', {
    attrs: {
      "module": _vm.module
    }
  }), _vm._v(" "), _c('v-Navbar', {
    attrs: {
      "nav-data": _vm.navData,
      "module": _vm.module
    },
    on: {
      "setModule": _vm.setModule
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-main"
  }, [_c('div', {
    staticClass: "bread"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("主页")]), _vm._v(" "), (_vm.moduletext) ? _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.moduletext))]) : _vm._e(), _vm._v(" "), (_vm.subtext) ? _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.subtext))]) : _vm._e(), _vm._v(" "), (_vm.actiontext) ? _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.actiontext))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd25b26a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 131
// module chunks = 1